import { initData } from '@/api/user'

export default {
  data() {
    return {
      url: '',
      listData: [],
      words: '',
      page: 1, // params的page需要-1,接口文档是从0开始.
      size: 10,
      total: 0,
      params: {},
      time: 170,
      // query 各自在页面定义
      sort: ''
    }
  },
  watch:{
    page(newValue){
      this.init();
    }
  },
  computed: {
    pageSize(){
      return Math.ceil(this.total / this.size);
    },
  },
  methods: {
    async init() {
      if (!await this.beforeInit()) {
        return
      }
      return new Promise((resolve, reject) => {
        this.$vs.loading();
        initData(this.url, this.params).then(res => {
          console.log(res);
          this.total = +res.data.totalElements;
          this.listData = res.data.content;
          if(this.statistics){
            this.statistics = res.statistics || res.data.statistics;
          }
          setTimeout(() => {
            this.$vs.loading.close();
          }, this.time)
          resolve(res)
        }).catch(err => {
          this.$vs.loading.close();
          reject(err)
        })
      })
    },
    beforeInit() {
      return true
    },

    // todo需要另外调整
    pageChange(e) {
      this.page = e ;
      this.init();
    },
    sizeChange(e) {
      this.page = 1;
      this.size = e;
      this.init();
    },
    toQuery(){
      this.page = 1;
      this.init();
    },
    // 排序
    sortChange(column){
      this.sort = `${column.prop},${column.order == 'ascending' ? 'asc' : 'desc' }`;
      this.init();
    }
  }
}
